import { Link, LinkProps } from '@mui/material';
import { uiEventDataAttrs } from '../../utils/analytics/ui-tracking';
import { Button } from '@upheal/design-system/components/Button/Button';
import { LinkButtonProps } from '@upheal/design-system/components/Button/Button.types';

interface SupportArticleLinkOwnProps {
    anchor?: string;
    uiLocation?: string;
}

interface SupportArticleLinkProps
    extends LinkProps,
        SupportArticleLinkOwnProps {}

/**
 * @deprecated Use a design system based `SupportArticleLinkV2` instead.
 */
export const SupportArticleLink = (props: SupportArticleLinkProps) => {
    const { uiLocation, href, anchor, children, ...rest } = props;
    const hrefResolved = `${href}${anchor ? `#${anchor}` : ''}`;

    return (
        <Link
            href={hrefResolved}
            target="_blank"
            rel="noreferrer"
            {...uiEventDataAttrs(
                'View Support Article',
                uiLocation,
                hrefResolved,
            )}
            {...rest}
        >
            {children}
        </Link>
    );
};

interface SupportArticleLinkPropsV2
    extends Omit<LinkButtonProps, 'variant'>,
        SupportArticleLinkOwnProps {}

export const SupportArticleLinkV2 = (props: SupportArticleLinkPropsV2) => {
    const { uiLocation, href, anchor, children, ...rest } = props;
    const hrefResolved = `${href}${anchor ? `#${anchor}` : ''}`;

    return (
        <Button
            variant="link"
            href={hrefResolved}
            target="_blank"
            rel="noreferrer"
            {...uiEventDataAttrs(
                'View Support Article',
                uiLocation,
                hrefResolved,
            )}
            {...rest}
        >
            {children}
        </Button>
    );
};
